"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.version = exports.prerelease = exports.patch = exports.minor = exports.major = exports.default = void 0;
const version = exports.version = "7.3.11";
const major = exports.major = Number("7");
const minor = exports.minor = Number("3");
const patch = exports.patch = Number("11");
const prerelease = exports.prerelease = undefined;
var _default = exports.default = version;